import axios from 'axios';
export default {
	state: {
		colleagues: [],
	},
	getters: {
		colleagues(state) {
			return state.colleagues;
		},
	},
	mutations: {
		setColleagues(state, payload) {
			state.colleagues = payload;
		},
	},
	actions: {
		getColleagues({ commit }) {
			return axios.get('auth/get_collegues/', {}).then(response => {
				let receivedData = response.data.collegues;

				receivedData.forEach(element => {
					console.log(element.ouser.phone);
					if (element.ouser?.phone?.length < 2) {
						return (element.ouser.phone = 'Номер не указан');
					}
				});

				commit('setColleagues', receivedData);
			});
		},
	},
};
